// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"18":"bc8cc61c","231":"4c671d54","679":"a09c12d7"}[chunkId] + ".js";
};